<template>
    <div>
        <el-form ref='buildForm' :rules='rules' :model="buildForm" label-width="80px" class="change-form">

            <el-row>
                <el-col :span="24">
                    <el-form-item label="标题" prop='title'>
                        <el-input v-model="buildForm.title" placeholder="请输入标题"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <el-form-item label="发布方式">
                        <el-radio-group v-model="buildForm.method_type" @change='changeMethod'>
                            <el-radio label="tag">tag发布</el-radio>
                            <el-radio label="branch">分支发布</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row v-if='buildForm.method_type === "tag"'>
                <el-col :span="24">
                     <el-form-item :label='"选取tag"' prop='method_value'>
                        <el-select
                        v-model="buildForm.method_value"
                        :remote-method="query => this.remoteMethod(query, buildForm.method_type)"
                        :loading="loading"
                        filterable
                        remote
                        clearable
                        allow-create
                        placeholder="请输入tag">
                            <el-option
                            v-for="(item, index) in sreach[buildForm.method_type]"
                            :key="index"
                            :label="item"
                            :value="item"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row v-if='buildForm.method_type === "branch"'>
                <el-col :span="24">
                     <el-form-item :label='"分支发布"' prop='method_value'>
                        <el-select
                        v-model="buildForm.method_value"
                        :remote-method="query => this.remoteMethod(query, buildForm.method_type)"
                        :loading="loading"
                        filterable
                        remote
                        clearable
                        allow-create
                        placeholder="请输入分支">
                            <el-option
                            v-for="(item, index) in sreach[buildForm.method_type]"
                            :key="index"
                            :label="item"
                            :value="item"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <el-form-item label="发布的主机">
                        <el-radio-group v-model="buildForm.target_type">
                            <el-radio label="group_name">组名</el-radio>
                            <el-radio label="server_list">主机列表</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <el-form-item label="组名"  v-if='buildForm.target_type === "group_name"' prop='target_value'>

                        <el-select
                        v-model="buildForm.target_value"
                        allow-create
                        :remote-method="query => this.remoteMethod(query, buildForm.target_type)"
                        :loading="loading" filterable remote clearable placeholder="请填写组名">
                            <el-option
                            v-for="(item, index) in sreach[buildForm.target_type]"
                            :key="index" :label="item" :value="item" />
                        </el-select>

                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <el-form-item label="主机列表" v-if='buildForm.target_type === "server_list"' prop='target_list'>

                        <el-select
                        v-model="buildForm.target_list"
                        allow-create
                        :remote-method="query => this.remoteMethod(query, buildForm.target_type)"
                        :loading="loading" filterable remote multiple reserve-keyword placeholder="请填写主机列表">
                            <el-option
                            v-for="(item, index) in sreach[buildForm.target_type]"
                            :key="index" :label="item" :value="item"/>
                        </el-select>

                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item>
                        <el-button type='primary' @click='SubmitFn("buildForm")'>发布</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import services from '../../cicd.services'
    import { buildParams } from '../../cicd.rules'
    const rules = buildParams()
    export default {
        data() {
            return {
                buildForm: {
                    target_type: 'group_name',
                    method_type: 'tag',
                },
                search_criteria: {},
                sreach: {},
                loading: false,
                rules
            }
        },

        created() {
            this.getTag()
        },
        
        methods: {
            // 获取参数
            getParams() {
                let buildForm = this.buildForm
                return {
                    title: buildForm.title,
                    app: this.$route.params.id,
                    user_name: localStorage.getItem('internalUserid'),
                    user_cn_name: localStorage.getItem('name'),
                    env: this.$route.params.env,
                    method_type: buildForm.method_type,
                    method_value: buildForm.method_value,
                    target_type: buildForm.target_type,
                    target_value: buildForm.target_type === 'group_name' ? buildForm.target_value : buildForm.target_list
                }
            },

            // 发布按钮
            SubmitFn(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                                            lock: true,
                                            text: 'Loading',
                                            spinner: 'el-icon-loading',
                                            background: 'rgba(0, 0, 0, 0.7)'
                                        });
                        let params = this.getParams()
                        services.deployCreate(params)
                            .then(res => {
                                this.$message.success('发布成功')
                                if (typeof(res.id) === 'number') {
                                    let params = {
                                        deploy_id: res.id,
                                        user_name: localStorage.getItem('internalUserid')
                                    }
                                    this.$router.push({
                                        name: "BuildLog",
                                        params: {
                                            id: this.$route.params.id,
                                            selfId: res.id,
                                            pid: res.pid
                                        }
                                    })
                                    services.deployRun(params)
                                        .then(() => {
                                            this.$message.success('正在执行部署单')
                                            this.$router.push({
                                                name: "BuildLog",
                                                params: {
                                                    id: this.$route.params.id,
                                                    selfId: res.id
                                                }
                                            })
                                        })
                                        .catch(err => this.$message.error(err.message))
                                }    
                            })
                            .catch(err => this.$message.error(err.message))
                            .finally(() => {
                                loading.close()
                            })
                    } else {
                        return false;
                    }
                });
            },

            getTag() {
                services.gitlabSearch({ app_id: this.$route.params.id })
                    .then(res => {
                            this.search_criteria = {
                                ...this.search_criteria,
                                tag: res.tags,
                                branch: res.branches
                            }
                        })
                    .catch(err => this.$message.error(err.message))
                services.hostsSearch({ appId: this.$route.params.id, envId: this.$route.params.env })
                    .then(res => (this.search_criteria = {
                        ...this.search_criteria,
                        group_name: res.group_name,
                        server_list: res.server_list
                    }))
            },

            // 选取发布方式
            changeMethod(type) {
                this.sreach[this.buildForm.method_type] = []
                this.buildForm.method_Value = ''
            },

            // 请求搜索
            remoteMethod (query, title) {
                if (query !== '') {
                    this.loading = true
                    setTimeout(() => {
                        this.loading = false
                        this.sreach[title] = this.search_criteria[title] && this.search_criteria[title].filter(item => {
                            switch (typeof(item)){
                                case 'string':
                                    return item.toLowerCase().includes(query.toLowerCase());
                                    break;
                                default:
                                    item.host_name.toLowerCase().includes(query.toLowerCase())
                                    || item.ip.toLowerCase().includes(query.toLowerCase())
                                    break;
                            }
                        });
                    }, 200);
                } else {
                    this.sreach[title] = [];
                }
            },

        }
    }
</script>

<style>

</style>
